module.exports = __webpack_public_path__ + "img/tree-01-g-trunk.637878a3.png";